window.addEventListener("load", (event) => {
    const loader = document.querySelector('.loader-wrapper');
    const body = document.body;
    body.style.overflowY = 'hidden';
    setTimeout(() => {
        loader.classList.add('hide-loader');
        body.style.overflowY = 'auto';
    }, 400);
});
